import React from 'react';
import { connect } from 'react-redux';

import { updateBoundingRect } from './state';

const elementResizeEvent = require('element-resize-event');
const unbind = require('element-resize-event').unbind;

/**
 * Registry class that maintains component
 * metadata in redux state. Currently this
 * includes only the BoundingClientRect().
 *
 * !!! Lookup is by HTML id attribute. !!!
 */
class Registry extends React.Component {
  constructor (props) {
    super(props);
    this.componentId = props.componentId;
    this.element = null;
    this.boundingRect = null;
  }

  componentDidMount () {
    this.updateElementRef();
  }

  componentWillUnmount () {
    if (this.element) {
      unbind(this.element);
    }
  }

  componentDidUpdate () {
    this.updateElementRef();
  }

  updateElementRef = () => {
    // DOM elements are indexed by ID so its very fast to check
    // the DOM reference with every update. This also prevents using
    // a stale/no-longer-existing DOM reference.
    const element = document.getElementById(this.componentId);
    if (element && element !== this.element) {
      // clean up previous.
      if (this.element) { unbind(this.element); }

      // assign new
      this.element = element;

      // attach new resize listener
      // this will catch all resize events on the element.
      elementResizeEvent(this.element, () => {
        this.computeBoundingRect();
      });

      // set initial size
      this.computeBoundingRect();
    }
  }

  computeBoundingRect = () => {
    if (this.element && this.element.getBoundingClientRect) {
      const boundingRect = this.element.getBoundingClientRect();

      // Only dispatch actions if we have an element size change.
      if (
        !this.boundingRect ||
        boundingRect.width !== this.boundingRect.width ||
        boundingRect.height !== this.boundingRect.height
      ) {
        this.boundingRect = boundingRect;
        this.props.dispatch(updateBoundingRect({ id: this.componentId, boundingRect }));
      }
    }
  }

  render () {
    const { componentId, WrappedComponent, ...rest } = this.props;
    return <WrappedComponent {...rest} />;
  }
}

const mapStateToProps = state => ({
  screenWidth: state.device.screenWidth,
  screenHeight: state.device.screenHeight,
  orientation: state.device.orientation
});

const ConnectedRegistry = connect(mapStateToProps)(Registry);

/**
 * HOC for tracking information about components.
 * In particular, its current dimensions.
 * The componentId is used to lookup component
 * metadata from the DOM and also retrieve metadata
 * from redux state.
 */
export const register = (componentId) => {
  return (WrappedComponent) => {
    return (props) => {
      return (
        <ConnectedRegistry
          componentId={componentId}
          WrappedComponent={WrappedComponent}
          {...props}
        />
      );
    };
  };
};
